
export default {
  name: 'Calendar',
};
